<template>
  <div class="app-container">
    <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="90px" style="width: 50%; ">
      <el-form-item :label="$t('account.username')" prop="username">
        <el-input v-model="name" :disabled="true" />
      </el-form-item>
      <el-form-item :label="$t('account.password')" prop="password">
        <el-input v-model="temp.password" clearable :placeholder="$t('account.passwordPlaceholder')" />
      </el-form-item>
      <!-- <el-form-item :label="$t('account.avatar')" prop="img">
        <Uploadone v-model="temp.img" :config="config" :header="header" />
      </el-form-item> -->
      <!-- <el-form-item :label="$t('account.name')" prop="realname">
        <el-input v-model="temp.realname" clearable />
      </el-form-item> -->
      <el-form-item :label="$t('account.googleAuthenticator')" prop="googleAuthenticator">
        <div v-if="temp.google_auth_is_bind" style="color:green"><i class="el-icon-check" />{{ $t('account.gaBound') }}&nbsp;&nbsp;&nbsp;<el-button @click="getGoogleAuthInfo()">{{ $t('account.gaRebind') }}</el-button></div>
        <div v-if="!temp.google_auth_is_bind" :loading="getGAILoading" type="primary" @click="getGoogleAuthInfo()"><el-button >{{ $t('account.gaStartBind') }}</el-button></div>
        <br />
        <div v-if="google_auth_qrcode_url">
          <img :src="google_auth_qrcode_url">
          <br />
          <el-input v-model="temp.google_auth_code" style="width: 300px;" :placeholder="$t('account.gaPlaceholder')" />
        </div>
      </el-form-item>
    </el-form>
    <el-button :loading="btnLoading" type="primary" @click="saveData()">{{ $t('common.save') }}</el-button>
  </div>
</template>

<script>
// import Uploadone from '@/components/Upload/singleImage'
import { modify, getGoogleAuthInfo } from '@/api/user'
import { validPassword } from '@/utils/validate'
import { mapGetters } from 'vuex'
import store from '@/store'
import myconfig from '@/settings.js'
import { getToken } from '@/utils/auth'

export default {
  name: 'MyInfo',
  // components: { Uploadone },
  data() {
    var checkPassword = (rule, value, callback) => {
      if (!value || validPassword(value)) {
        callback()
      } else {
        return callback(new Error())
      }
    }
    return {
      btnLoading: false,
      getGAILoading: false,
      temp: {
        password: '',
        // realname: store.getters.realname,
        google_auth_is_bind: store.getters.google_auth_is_bind,
        img: store.getters.avatar,
        google_auth_code: '',
      },
      google_auth_qrcode_url:'',
      // config: {
      //   fileName: 'img',
      //   multiple: true,
      //   accept: 'image/*',
      //   action: myconfig.uploadUrl.img
      // },
      header: {
        'x-access-appid': myconfig.appid,
        'x-access-token': getToken()
      },
      rules: {
        password: [{ validator: checkPassword, message: this.$t('formRules.passwordFormat'), trigger: 'blur' }],
      }
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'admin_type'
    ])
  },
  watch: {
    temp: {
      handler() {},
      immediate: true,
      deep: true
    }
  },
  created() {

  },
  destroyed() {

  },
  methods: {
    getGoogleAuthInfo() {
      if(!this.$store.getters.name) {
        this.$message.error(this.$t('formRules.username'))
        return
      }
      this.getGAILoading = true
      getGoogleAuthInfo({username: this.$store.getters.name}).then(res => {
        this.temp.google_auth_secret = res.data.google_auth_secret
        this.google_auth_qrcode_url = res.data.google_auth_qrcode_url
        this.getGAILoading = false
      })
    },
    saveData() {
      this.btnLoading = true
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const _this = this
          modify(this.temp).then(response => {
            if (response.status === 1) {
              _this.$message.success(response.msg)

              if(this.temp.google_auth_code) {
                store.commit('user/SET_GOOGLE_AUTH_IS_BIND', 1)
                store.commit('user/SET_IS_FIRST_LOGIN', 0)
              }
            } else {
              _this.$message.error(response.msg)
            }
            _this.btnLoading = false
          // eslint-disable-next-line handle-callback-err
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          this.btnLoading = false
        }
      })
    }
  }
}
</script>
